<template>
  <div id="sidebarmenu">
    <div v-for="(item, index) in items" :key="index">
      <div v-if="item.submenu">
        <div
          v-if="
            activePage.slug === item.slug ||
              activePage.slug === item.submenu[0].slug ||
              activePage.slug === item.submenu[1].slug
          "
        >
          <ItemDropdown
            :Name="item.name"
            :Url="item.url"
            :Slug="item.slug"
            :Submenu="item.submenu"
            :isActive="true"
          />
        </div>
        <div v-else>
          <ItemDropdown
            :Name="item.name"
            :Url="item.url"
            :Slug="item.slug"
            :Submenu="item.submenu"
            :isActive="false"
          />
        </div>
      </div>
      <div v-else>
        <div v-if="activePage.slug === item.slug">
          <ItemLink
            :Name="item.name"
            :Slug="item.slug"
            :Url="item.url"
            :isActive="true"
          />
        </div>
        <div v-else>
          <ItemLink
            :Name="item.name"
            :Slug="item.slug"
            :Url="item.url"
            :isActive="false"
          />
        </div>
      </div>
    </div>
    <div class="text-lg w-full mb-20 cus-button pointer" @click="LogoutAdmin()">
      ออกจากระบบ
    </div>
  </div>
</template>

<script>
import items from "./sidebar_item";
import ItemDropdown from "./item_dropdown.vue";
import ItemLink from "./item_link.vue";

import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters({
      activePage: "general/activePage"
    })
  },

  components: {
    ItemLink,
    ItemDropdown
  },
  data() {
    return {
      items: items
    };
  },

  methods: {
    LogoutAdmin() {
      this.$store.dispatch("general/logout");
    }
  }
};
</script>

<style lang="scss" scoped>
#sidebarmenu {
  margin-top: 20px;
  margin-bottom: 10rem;
}
.cus-button {
  display: flex;
  justify-content: start;
  padding: 15px 20px;
  text-decoration: none;

  &:hover {
    transition: 100ms;
    padding-left: 30px;
  }
}
</style>
